"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col } from "react-bootstrap";
import homeStyles from "@/styles/Home.module.scss";
import DotLoader from "../dotLoader/DotLoader";
interface ActivityHeaderProps {
  readonly showViewAll: boolean;
  readonly fetching: boolean;
}
export default function ActivityHeader(t0) {
  const $ = _c(6);
  const {
    showViewAll,
    fetching
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1>NFT Activity</h1>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fetching || $[2] !== showViewAll) {
    t2 = showViewAll ? <Link href="/nft-activity" className={homeStyles.viewAllLink}><span>View All</span></Link> : fetching && <DotLoader />;
    $[1] = fetching;
    $[2] = showViewAll;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Col sm={12} md={6} className="d-flex align-items-center justify-content-between"><span className="d-flex flex-wrap align-items-center gap-3">{t1}{t2}</span></Col>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}